<template>
  <div>
    <BaseInputWithContextMenu
      :target-id="inputElementId"
      :is-read-only="isReadOnlyState"
      :value="Value"
      :control="$attrs.control"
      :additional-menu-items="additionalMenuItems"
      :enable-speech-features="true"
      :enable-system-options="true"
      @input="onInput"
      @control-changed="setChangedStatus"
      @context-menu-select="handleContextMenuSelect"
    >
      <b-form-textarea
        v-b-tooltip.hover :title="Hint"
        :max-rows="MaxRows"
        :class="componentClass"
        :maxlength="this.$attrs.control.controlMaxLenght"
        v-model="Value"
        v-on:change="OnChange"
        v-bind:style="style"
        no-resize
        :ControlId="controlID"
        :readonly="this.$attrs.control.isReadOnly || NoteIsVoid || this.$attrs.control.IsChartReview || this.isReadOnly"
        v-on:blur="OnBlur($event)"
        v-on:input="onInput"
        :id="inputElementId"
        ref="inputTextarea"
      ></b-form-textarea>
    </BaseInputWithContextMenu>

    <button
      v-if="!isReadOnlyState && $store.state.useAIAssist"
      :style="aiButtonStyle"
      type="button"
      :title="$t('AiWriter.HelpMeWrite')"
      @click="openAiWriter"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#19BEE8" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5Z"/>
        <path d="M19 15l.75 2.25L22 18l-2.25.75L19 21l-.75-2.25L16 18l2.25-.75Z"/>
        <path d="M5 3l.5 1.5L7 5l-1.5.5L5 7l-.5-1.5L3 5l1.5-.5Z"/>
      </svg>
    </button>

    <b-modal
      v-model="showAiPanel"
      :id="'ai-writer-modal-' + controlID"
      :title="$t('AiWriter.Title')"
      hide-footer
      size="md"
      @shown="makeAiModalDraggable"
      @hidden="resetAiPanel"
    >
      <div class="ai-writer-body">
        <label class="ai-label">{{ $t('AiWriter.WhatToWrite') }}</label>
        <b-form-textarea
          ref="aiInstructionInput"
          v-model="aiInstruction"
          :placeholder="$t('AiWriter.Placeholder')"
          rows="3"
          class="ai-instruction-input"
          :disabled="isGenerating"
        ></b-form-textarea>

        <div class="mt-2 d-flex justify-content-end">
          <b-button
            variant="primary"
            size="sm"
            :disabled="isGenerating || !aiInstruction.trim()"
            @click="generateText"
          >
            <span v-if="isGenerating">{{ $t('AiWriter.Generating') }}</span>
            <span v-else>{{ $t('AiWriter.Generate') }}</span>
          </b-button>
        </div>

        <div v-if="aiError" class="mt-2 text-danger small">{{ aiError }}</div>

        <div v-if="aiGeneratedText" class="ai-preview mt-3">
          <label class="ai-label">{{ $t('AiWriter.GeneratedText') }}</label>
          <b-form-textarea
            v-model="aiGeneratedText"
            class="ai-preview-text"
            rows="5"
            max-rows="10"
          ></b-form-textarea>
          <div class="mt-2 d-flex justify-content-end">
            <b-button variant="primary"           size="sm" class="mr-1" @click="insertText">{{ $t('AiWriter.Insert') }}</b-button>
            <b-button variant="outline-primary"   size="sm" class="mr-1" @click="replaceText">{{ $t('AiWriter.Replace') }}</b-button>
            <b-button variant="outline-primary"   size="sm" class="mr-1" :disabled="isGenerating" @click="generateText">{{ $t('AiWriter.Regenerate') }}</b-button>
            <b-button variant="outline-secondary" size="sm" @click="closeAiWriter">{{ $t('AiWriter.Discard') }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>

   <!-- <MdPatientDiagCodes v-if="activateModalDiagCodes"
      v-bind:ModalId="controlID"
      v-bind:PatientCode="this.PatientCode"
      v-bind:RecordId="this.$attrs.AdmissionRecId"
      v-bind:DateFrom="this.DateFrom"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientDiagCodes>-->

        <DiagnosisMainModal v-if="activateModalDiagCodes"
            :ModalId="controlID"
            @getCancel="onCancel($event)"
            :TitleWindow="outComeTitle"
            :OpenforClinical="true"
            @UpdateDiagnosis="onCodeConditionOk"
            :ReadOnly="false"
            :PatientCode="this.PatientCode">
        </DiagnosisMainModal>

    <MdPatientInsurances v-if="activateModalInsurance"
      v-bind:ModalId="controlID"
      v-bind:AdmissionRecordId="this.$attrs.AdmissionRecId"
      v-bind:PatientCode="this.PatientCode"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientInsurances>

    <MdPatientContacts v-if="activateModalContacts"
      v-bind:ModalId="controlID"
      v-bind:PatientCode="this.PatientCode"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientContacts>

    <MdPatientAllergiesOutCome v-if="activateModalAllergies"
      v-bind:ModalId="controlID"
      v-bind:PatientCode="this.PatientCode"
      v-bind:AdmissionRecordId="this.$route.params.recordid"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientAllergiesOutCome>

    <MdGenericOutCome v-if="activateModalGeneric"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      v-bind:outComeCode="outComeCode"
      v-bind:outComeDescription="outComeDescription"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdGenericOutCome>

    <MdPainAssessmentNotesOutCome v-if="activeModalPainAssessment"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      v-bind:outComeCode="outComeCode"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPainAssessmentNotesOutCome>

    <MdPatientVitalSingOutCome v-if="activeModalVitalSign"
      v-bind:ModalId="controlID"
      v-bind:PatientCode="this.PatientCode"
      v-bind:TitleWindow="outComeTitle"
      v-bind:outComeCode="outComeCode"
      v-bind:ComponentKind="'Memo'"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientVitalSingOutCome>

    <MdTreatmentPlanOutCome v-if="activeModalTreatmentPlan"
      v-bind:HeaderObj="this.$attrs.Header"
      v-bind:ModalId="controlID"
      v-bind:AdmissionRecordId="this.$attrs.AdmissionRecId"
      v-bind:PatientCode="this.PatientCode"
      v-bind:TitleWindow="outComeTitle"
      v-bind:outComeCode="outComeCode"
      v-bind:ComponentKind="'Memo'"
      @TreatmentPlanCompleted="Completed"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    >
    </MdTreatmentPlanOutCome>

    <MdGetLastAnswers v-if="showGetLastAnswers"
      @getCancel="onCancelGetLastAnswers($event)"
      @getOK="onOKGetLastAnswers($event)"
      v-bind:ControlId="controlID"
      v-bind:PatientCode="PatientCode"
      v-bind:TransDate="TransDate"
    />

    <MdPatientMedicationsOutCome v-if="activateModalMedications"
      v-bind:ModalId="controlID"
      v-bind:PatientCode="this.PatientCode"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientMedicationsOutCome>

    <!-- <MdTextSpeech></MdTextSpeech> -->
  </div>
</template>

<script>
  import Utils from '@/common/utils.js'
  import { EventBus } from '../../event-bus.js';
  import Vue from 'vue';
  import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";
  import ApiService from '@/services/api.service';

  Vue.use(ContextMenuPlugin);
  export default {
    mixins: [EventBus],
    props: {
     MaxRows: String,
     Rows: String,
     MaxLength: String,
     isReadOnly:Boolean,
     value:[String],
     Name:String,
     Placeholder:String,
     TransDate: String,
     NoteId: String,
     DateFrom:String,
     id: [String, Number],
     PatientCode: String,
     IsCommonPart: Boolean,
     IsGroupContainer: Boolean,
     aiAssistContext: String,
     FormId: String,
   },
    data() {
      return {
         Value: this.value,
          NoteIsVoid:false,
         style: {
          position:'absolute',
          border: 'solid 1px #e0e0e0 !important',
          borderRadius: '5px',
          padding: '4px 6px',
          backgroundImage: 'linear-gradient(130deg, white, rgb(241, 253, 255))',
          top: this.$attrs.control.controlTop+'px',
          width:this.$attrs.control.controlWidth+'px',
          height:this.$attrs.control.controlHeight+'px',
          left:this.$attrs.control.controlLeft+'px',
          fontSize:'',
          fontWeight: '',
          fontFamily:'',
          cursor: 'default',
          color:'',
          textDecorationLine:'',
          fontStyle:'',
          textAlign: 'left',
          borderColor: '#e0e0e0 !important',
        },
         Hint: this.$attrs.control.controlHint,
         controlID:String(this.$attrs.control.controlID),
         outComeDescription: Utils.strToTitleCase(this.$attrs.control.outComeDescription),
         outComeTemplateCode:this.$attrs.control.outComeTemplateCode,
         outComeTitle: Utils.strToTitleCase(this.$attrs.control.outComeDescription),
         outComeCode:this.$attrs.control.outComeCode,
         Invalid:false,
         isRequired: this.$attrs.control.isRequired,
         activateModalInsurance:false,
         activateModalContacts:false,
         activateModalDiagCodes:false,
         activateModalAllergies:false,
         activateModalGeneric:false,
         activeModalPainAssessment:false,
         activeModalVitalSign:false,
         activeModalTreatmentPlan:false,
         showGetLastAnswers: false,
         activateModalMedications: false,
         //PatientCode: this.$route.params.id,
         componentClass: this.$attrs.control.outComeCode ? 'cutescroll cursor-context-menu outcome' : 'cutescroll cursor-context-menu',
         menuItems:[],
         targetId: "target-"+this.$attrs.HeaderId+"-"+this.$attrs.control.controlID,
         menuTargetId:"#target-"+this.$attrs.HeaderId+"-"+this.$attrs.control.controlID,
         cmpLoaded : false,
         // AI Writer
         showAiPanel: false,
         aiInstruction: '',
         aiGeneratedText: '',
         aiError: '',
         isGenerating: false
      }
    },
    computed: {
      inputElementId() {
        return this.$attrs.HeaderId + '-' + this.$attrs.control.controlID;
      },

      isReadOnlyState() {
        return this.$attrs.control.isReadOnly || this.NoteIsVoid || this.$attrs.control.IsChartReview || this.isReadOnly;
      },

      aiButtonStyle() {
        const ctrl = this.$attrs.control;
        return {
          position: 'absolute',
          top: (parseInt(ctrl.controlTop) + 4) + 'px',
          left: (parseInt(ctrl.controlLeft) + parseInt(ctrl.controlWidth) - 32) + 'px',
          zIndex: 2,
          background: 'none',
          border: 'none',
          padding: '0',
          cursor: 'pointer',
          lineHeight: '1',
          opacity: '1'
        };
      },

      additionalMenuItems() {
        const items = [];
        if (!this.IsCommonPart) {
          items.push({ text: this.$t('ContextMenu.GetLast10'), id: "gettenlastans" });
        }
        if(this.outComeDescription) {
          items.push({text: this.outComeDescription, id: "outcome"})
        }
        return items;
      }
    },
    watch: {
      value: {
        immediate: true,
        handler: function(newModel) {
          this.Value = newModel;
        }
      }
    },

    methods:{

     deActivateModal(){
       if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDPATIENTCONTACTS')
       this.activateModalContacts = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMPATIENTINSURANCES')
       this.activateModalInsurance = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMPATIENTDIAGCODES')
       this.activateModalDiagCodes = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMALLERGIESEHR')
       this.activateModalAllergies = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFMMDNOTEOUTCOMESTUDIES')
       this.activateModalGeneric = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDPAINASSESSMENTNOTES')
       this.activeModalPainAssessment = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDVITALSIGNSNOTES')
       this.activeModalVitalSign = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMTREATMENTPLANNOTES')
        this.activeModalTreatmentPlan = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMCUSTOMPATIENTMEDICATIONS')
        this.activateModalMedications = false

     },

     onCancel(){
       this.deActivateModal()
     },

     Completed(){
      this.Value = this.$t('treatmentplan.Completed');
      this.$emit('input', this.Value)
      this.setChangedStatus(this.Value);
     },

     OnChange(value){
       this.Invalid = value.length == 0 && this.isRequired ? true : false;
       this.style.borderColor = this.Invalid ? '#dc3545 !important': '#e0e0e0 !important'
       this.$emit('input',value)
     },

     onCodeConditionOk(result) {
       if(result) {
          this.Value = result;
          this.$emit('input', result);
          this.setChangedStatus( result );
       }
       this.deActivateModal()
     },

     OnBlur(evt){
       this.$emit('blur',evt.target.value)
       this.Invalid = evt.target.value.length == 0 && this.isRequired ? true : false;
       this.style.borderColor = this.Invalid ? '#dc3545 !important': '#e0e0e0 !important'
     },

     InitializeVariables(){
       if(this.$attrs.control.controlColorForHtml)
          this.style.backgroundColor = this.$attrs.control.controlColorForHtml;
       else if(this.$attrs.control.isReadOnly || this.isReadOnly)
          this.style.backgroundColor = '#e9ecef !important'
       if(this.$attrs.control.controlFontForHtml){
          this.controlFont = this.$attrs.control.controlFontForHtml.split(',');
          var size = parseInt(this.controlFont[1]) + 2;
          this.style.fontFamily = this.controlFont[0];
          this.style.fontSize = size+'px !important';
          this.style.color = this.controlFont[3];
          var Decorations = this.controlFont[2];
          this.style.fontWeight = Decorations.charAt(0) === '1'?'bold':'';
          this.style.fontStyle = Decorations.charAt(1) === '1'?'italic':'';
          this.style.textDecorationLine = Decorations.charAt(2) === '1'?'underline':'';
          this.style.textDecorationLine = Decorations.charAt(3) === '1'?this.style.textDecorationLine+ ' line-through':this.style.textDecorationLine;
       }
       this.setAlignment();
       this.cmpLoaded = 'MdTextSpeech' in Vue.options.components;
    },

    setAlignment() {
       if(this.$attrs.control.alignment) {
          if(this.$attrs.control.alignment === 'taCenter')
            this.style.textAlign = 'center'
          if(this.$attrs.control.alignment === 'taLeftJustify')
            this.style.textAlign = 'left'
          if(this.$attrs.control.alignment === 'taRightJustify')
            this.style.textAlign = 'right'
       }
     },

    showModal() {
      if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDPATIENTCONTACTS')
       this.activateModalContacts = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMPATIENTINSURANCES')
       this.activateModalInsurance = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMPATIENTDIAGCODES')
       this.activateModalDiagCodes = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMALLERGIESEHR')
       this.activateModalAllergies = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFMMDNOTEOUTCOMESTUDIES')
       this.activateModalGeneric = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDPAINASSESSMENTNOTES')
       this.activeModalPainAssessment = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDVITALSIGNSNOTES')
       this.activeModalVitalSign = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMTREATMENTPLANNOTES')
       this.activeModalTreatmentPlan = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMCUSTOMPATIENTMEDICATIONS')
        this.activateModalMedications = true
    },

    showModalGetLastAnswers() {
      this.showGetLastAnswers = true
    },

    onCancelGetLastAnswers(){
      this.showGetLastAnswers = false
    },

    onOKGetLastAnswers(value) {
      this.Value = value;
      this.$emit('input', value)
      this.showGetLastAnswers = false;
      this.setChangedStatus( value );
    },

    handlerClick(evt){
      if(!this.$attrs.control.isReadOnly && !this.isReadOnly) {
        this.$refs.menu.open(evt)
      }
    },

    setValid(state){
        this.style.borderColor = state ? '#dc3545 !important': '#e0e0e0 !important'
    },

    setRequired(value) {
      this.isRequired = value;
      if (!value) {
        this.style.borderColor = '#e0e0e0 !important';
      } else if (this.Value === null || this.Value === undefined || this.Value.length === 0) {
        this.style.borderColor = '#dc3545 !important';
      }
    },

    setChangedStatus(){
      var changed = {
        "ControlId":this.$attrs.control.controlID,
        "Changed":true,
        "NoteId":this.NoteId
      }
      EventBus.$emit('onControlWasChanged', changed);
    },

    onInput(value) {
      this.Value = value;
      this.$emit('input',value)
      this.setChangedStatus(value);
    },

    ChangeValue(value) {
        this.onInput(value);
        this.OnChange(value);
    },

    // Managing custom context menu items
    handleContextMenuSelect(itemId) {
      if (itemId === 'gettenlastans') {
            this.showModalGetLastAnswers();
      }
      if(itemId === 'outcome') {
         this.showModal()
       }
    },

    makeAiModalDraggable() {
      this.$nextTick(() => {
        const modalId = 'ai-writer-modal-' + this.controlID;
        const outer = document.getElementById(`${modalId}___BV_modal_outer_`);
        const dialog = outer?.querySelector('.modal-dialog');
        const header = outer?.querySelector('.modal-header');
        if (!dialog || !header) return;
        header.style.cursor = 'move';
        let dragging = false, offsetX = 0, offsetY = 0;
        header.onmousedown = (e) => {
          e.preventDefault();
          const rect = dialog.getBoundingClientRect();
          offsetX = e.clientX - rect.left;
          offsetY = e.clientY - rect.top;
          dragging = true;
          dialog.style.position = 'fixed';
          dialog.style.margin = '0';
          dialog.style.transform = 'none';
          dialog.style.width = `${rect.width}px`;
          dialog.style.left = `${rect.left}px`;
          dialog.style.top = `${rect.top}px`;
        };
        document.onmousemove = (e) => {
          if (!dragging) return;
          dialog.style.left = `${e.clientX - offsetX}px`;
          dialog.style.top = `${e.clientY - offsetY}px`;
        };
        document.onmouseup = () => { dragging = false; };
        this.$refs.aiInstructionInput.focus();
      });
    },

    openAiWriter() {
      this.showAiPanel = true;
    },

    closeAiWriter() {
      this.showAiPanel = false;
    },

    resetAiPanel() {
      this.aiInstruction = '';
      this.aiGeneratedText = '';
      this.aiError = '';
      this.isGenerating = false;
    },

    async generateText() {
      if (!this.aiInstruction.trim()) return;
      this.isGenerating = true;
      this.aiError = '';
      this.aiGeneratedText = '';
      try {
        const payload = {
          instruction: this.aiInstruction,
          formId: this.FormId,
          controlId: this.controlID,
          patientCode: this.PatientCode,
          transDate: this.TransDate,
        };
        if (this.Value) payload.existingText = this.Value;
        if (this.aiAssistContext) payload.context = this.aiAssistContext;
        const response = await ApiService.post('AiAssist', payload);
        this.aiGeneratedText = response.data.generatedText || '';
      } catch {
        this.aiError = this.$t('AiWriter.Error');
      } finally {
        this.isGenerating = false;
      }
    },

    insertText() {
      const updated = (this.Value ? this.Value + '\n' : '') + this.aiGeneratedText;
      this.Value = updated;
      this.$emit('input', updated);
      this.setChangedStatus(updated);
      this.closeAiWriter();
    },

    replaceText() {
      this.Value = this.aiGeneratedText;
      this.$emit('input', this.aiGeneratedText);
      this.setChangedStatus(this.aiGeneratedText);
      this.closeAiWriter();
    },

    setValueS2T( sp ){
      const el = document.getElementById(this.inputElementId);
      const start = el ? el.selectionStart : null;
      const end = el ? el.selectionEnd : null;
      const current = this.Value || '';
      const sp2t = start !== null
        ? current.substring(0, start) + sp + current.substring(end)
        : current + sp;
      this.Value = sp2t;
      this.$emit('input', sp2t);
      this.setChangedStatus( sp2t );
      this.$nextTick(() => {
        if (el && start !== null) {
          el.selectionStart = el.selectionEnd = start + sp.length;
        } else if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },

    setValueContinuousS2T( sp ){
       this.Value = sp
       //this.$emit('input', sp);
       this.setChangedStatus()

       this.$nextTick(() => {
          this.scrollFieldToEnd();
        });
     },

     setValueAIS2T( sp ){
      this.Value = sp
      this.$emit('input', sp);
      this.setChangedStatus()
     },

     scrollFieldToEnd() {
      const nativeEl = this.$refs.inputTextarea?.$el;
      if (nativeEl) {
        nativeEl.setSelectionRange(nativeEl.value.length, nativeEl.value.length);
        nativeEl.scrollLeft = nativeEl.scrollWidth;
        nativeEl.scrollTop = nativeEl.scrollHeight;
        return;
      }
     }
  },

  created(){
    EventBus.$on("onSetReadOnly", function (e,id) {
      if(this.$attrs.HeaderId === id){
        this.NoteIsVoid = e;
      }
    }.bind(this));

    if(this.$attrs.NoteIsVoid){
      this.NoteIsVoid = this.$attrs.NoteIsVoid;
    }

    EventBus.$on("receivedS2T", function (event) {
      if( event.ControlId == this.$attrs.control.controlID) {
        this.setValueS2T( event.finalSentence )
      }
    }.bind(this))

    EventBus.$on("receivedContinuousS2T", function (event) {
      if( event.ControlId == this.$attrs.control.controlID) {
        this.setValueContinuousS2T( event.finalSentence )
      }
    }.bind(this))

    EventBus.$on("receivedAIS2T", function (event) {
      if( event.ControlId == this.$attrs.control.controlID) {
        this.setValueAIS2T( event.finalSentence )
      }
    }.bind(this))
},

  mounted(){
    this.InitializeVariables();
    if (!this.IsCommonPart && this.IsGroupContainer && this.$attrs.control.isCommonControlNote) {
    this.Hint = this.$t('GroupNotesDashboard.ToCompletedInGroupFocus')
    }
  }
}
</script>

<style>
.scroll{
	overflow: hidden !important;
}


.ai-label {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin-bottom: 4px;
  display: block;
}

.ai-instruction-input {
  font-size: 13px;
}

.ai-preview {
  border-top: 1px solid #e0e0e0;
  padding-top: 12px;
}

.ai-preview-text {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 10px 12px;
  font-size: 13px;
  white-space: pre-wrap;
  max-height: 200px;
  overflow-y: auto;
}
</style>
